import {useMutation, useQueryClient} from "@tanstack/react-query";
import {LlmConfig} from "@/model/llmSpecification";
import llmConfigRepository from "@/repository/LlmConfigRepository";
import {SiteBunnyAdminError} from "@/error";

export const useUpdateLlmProviderConfig = (provider: string) => {
    const queryClient = useQueryClient()
    return useMutation<LlmConfig, SiteBunnyAdminError, LlmConfig>({
        mutationFn: async (body: LlmConfig) => {
            try {
                const {data} = await llmConfigRepository.update(provider, body);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["llmConfig"]
            })
        }
    })
}